import moment from 'moment';

import { getRouteParam, setRouteParams } from '../../../shared/utils/angularUtils';
import { isDatesInRange, isDatesValid } from '../../../shared/utils/dateUtils';
import { pathQueryParams } from '../../../shared/constants/pathQueryParams';
import { DateRange } from '../../interfaces/DateRange';
import { getDefaultDateRange } from '../getDefaultDateRange/getDefaultDateRange';

export const getDateRangeFromParams = (customerRegistrationDate: string): DateRange => {
  const startDate = getRouteParam(pathQueryParams.startDate);
  const endDate = getRouteParam(pathQueryParams.endDate);

  if (!startDate || !endDate) {
    return setDefaultRouteParams(customerRegistrationDate);
  }

  const parsedStartDate = moment(startDate);
  const parsedEndDate = moment(endDate);
  const parsedRegistrationDate = moment(customerRegistrationDate);
  const parsedToday = moment();

  const isAllDatesValid = isDatesValid([
    parsedStartDate,
    parsedEndDate,
    parsedRegistrationDate,
    parsedToday,
  ]);

  const isDatesInCorrectRange = isDatesInRange(
    [parsedStartDate, parsedEndDate],
    parsedRegistrationDate,
    parsedToday,
  );

  if (
    !isAllDatesValid ||
    !isDatesInCorrectRange ||
    parsedStartDate.isAfter(parsedEndDate)
  ) {
    console.error('Invalid date range parameters');
    return setDefaultRouteParams(customerRegistrationDate);
  }

  return {
    startDate,
    endDate,
  };
};

const setDefaultRouteParams = (customerRegistrationDate: string) => {
  const defaultDateRange = getDefaultDateRange(customerRegistrationDate);
  setRouteParams(defaultDateRange);
  return defaultDateRange;
};
